import { Component, HostListener, Injector } from '@angular/core';
import { HttpService } from '../../service/http.service';
import { ToastrService } from 'ngx-toastr';
import { Router, RouterLink } from '@angular/router';
import { FormsModule, UntypedFormBuilder } from '@angular/forms';
import { GlobalService } from '../../service/global.service';
import { WindowRefService } from '../../service/window-ref.service';
import { CommonModule } from '@angular/common';
import { ActiveCallChatStripComponent } from '../active-call-chat-strip/active-call-chat-strip.component';
import { apiConstants } from '../../constans/constants.module';

@Component({
  selector: 'app-addwallet',
  standalone: true,
  imports: [CommonModule, FormsModule, ActiveCallChatStripComponent, RouterLink],
  templateUrl: './addwallet.component.html',
  styleUrl: './addwallet.component.scss'
})
export class AddwalletComponent {
  showModal: boolean = false;
  isMobileScreen: boolean = false;
  walletAmount: any = {}
  enterAmount: any = {}
  activeIndex = 0;
  amount: number = 0;
  gst: number = 0;
  totalAmount: number = 0;
  userId: any = 0;
  discount: any = 0;
  cashbackAmount: any = 0;
  couponId: any = 0;
  totalWalletAmount: any = 0;
  values: any = "";
  condition: any = "";
  couponCode: any = ''
  platformType: any = ''
  applyBtn: any = 'Apply'
  btn: any = ''

  customerId: any;

  constructor(private _homeService: HttpService,
    injector: Injector,
    private toastr: ToastrService,
    private router: Router,
    private winRef: WindowRefService,
    private formBuilder: UntypedFormBuilder,
    public gS: GlobalService
  ) {
    // fall back to storage in case gS.userData isn't hydrated yet when this lazy module loads
    this.customerId = this.gS.userData?.id ?? this.gS.getUserDataFromStorage()?.id;

  }

  ngOnInit(): void {

    this.checkScreenSize();


    // if (this.timeZone.toLowerCase() == "asia/kolkata" || this.timeZone.toLowerCase() == "asia/calcutta") {
    //   this.indiaZone = true;
    //   this.currencyType = "INR";
    // }else{
    //   this.indiaZone = false;
    //   this.currencyType = "USD";
    // }

    if (this.customerId != null) {
      this.userId =   this.customerId;
      this.getWalletAmount();
    } else {
      this.toastr.error("Login to continue your session", "Opps !!!");
      this.router.navigate(['']);
    }
    this.condition = 'active';
    this.btn = 'non-disabled';
  }

  @HostListener('window:resize')
  checkScreenSize() {
    this.isMobileScreen = window.innerWidth < 476;
  }

  closeModal() {
    this.showModal = false;
  }


  getWalletAmount() {

    this._homeService.getRechargeAmount(this.customerId).subscribe((data) => {
      this.walletAmount = data;
      this.walletAmount = this.walletAmount.data;
      this.amount = this.walletAmount[0].amount;
      this.gst = (this.amount * 18 / 100);
      if (!this.gS.indiaZone) {
        this.gst = 0;
      }
      this.totalAmount = this.amount + this.gst;
      this.discount = this.walletAmount[0].discount ? (this.walletAmount[0].amount * this.walletAmount[0].discount / 100) : 0.0;
      console.log(this.discount);
    }, (error) => {
      console.log(error);
    });

    this._homeService.getUserWalletAmount(  this.customerId, 0).subscribe((data) => {
      let value: any = data;
      this.totalWalletAmount = value.availableBalance;
      localStorage.setItem('user_wallet_balance', value.availableBalance);
      console.log(this.totalWalletAmount);
      this.gS.userBalance=this.totalWalletAmount;
    }, (error) => {
      console.log(error);
    });
  }


  amountClick(amount: any, index: any) {
    // this.applyBtn = 'Apply';
    // this.condition = 'active';
    // this.btn = 'non-disabled';
    this.discount = amount.discount ? (amount.amount * amount.discount / 100) : 0.0

    this.activeIndex = index;
    this.amount = amount.amount;
    this.gst = (this.amount * 18 / 100);
    if (!this.gS.indiaZone) {
      this.gst = 0;
    }
    this.totalAmount = this.amount + this.gst;

    if (this.isMobileScreen) {
      this.showModal = true;
    }
  }


  createRzpayOrder() {
    this.startPayment();
  }


  startPayment() {

    let obj = {
      userId: this.userId,
      amount: this.amount,
      gst: this.gst,
      timeZone: localStorage.getItem("timeZone"),
      couponId: this.couponId,
      discount: this.discount,
    };

    this._homeService.startPaymentInitate(obj).subscribe((data) => {
      let value: any;
      value = data;
      if (value.status == "fail") {
        this.toastr.error("Something went wrong, please try again", "Opps !!!");
        // this.closeModal();
      } else {
        this.payWithRazor(value.data.paymentId);
      }
    }, (error) => {
      this.toastr.error("Please try again", "Something went wrong");
      console.log(error);
    });
  }


  payWithRazor(paymentIniateId: any) {

    // let live='rzp_live_2Ttr3VxeIjDkWK';
    // let test='rzp_test_L0i1ND4EXdvn1M';

    // let live='rzp_live_6U4bLS3UzH7oMW';
    // let test='rzp_test_U9dBm2WEb1hxhm';

    let live = apiConstants.RazorpayKey;
    let test = apiConstants.RazorpayTestKey;
    const options: any = {
      key: live,
      amount: this.totalAmount * 100, // amount should be in paise format to display Rs 1255 without decimal point
      currency: this.gS.currencyType,
      name: 'LegalStack', // company name or product name
      description: '',  // product description
      // order_id: val, // order_id created by you in backend
      modal: {
        // We should prevent closing of the form when esc key is pressed.
        escape: false,
      },
      notes: {
        "userId": this.userId,
        "astro_order_id": paymentIniateId
        // include notes if any
      },
      theme: {
        color: '#48A6A7'
      }
    };
    options.handler = ((response: any, error: any) => {
      options.response = response;
      this.paymentCapture(response, paymentIniateId);
      // call your backend api to verify payment signature & capture transaction
    });
    options.modal.ondismiss = (() => {
      this.toastr.error("Please try again", "Transaction cancelled.");
      // handle the case when user closes the form while transaction is in progress
      this.closeModal();
      console.log('Transaction cancelled.');
    });
    const rzp = new this.winRef.nativeWindow.Razorpay(options);
    rzp.open();
  }

  paymentCapture(gatewayid: any, transactionId: any) {
    let obj = {
      txID: transactionId,
      paymentGatewayTxID: gatewayid.razorpay_payment_id
    };

    this._homeService.completePayment(obj).subscribe((data) => {
      var value: any = data;
      if (value.status == "fail") {
        this.toastr.error("Something went wrong, please try again", "Ops");
      } else {
        console.log("Success");
        this.toastr.success("Wallet is recharged successfully", "Congratulations");
      }
    }, (error) => {
      console.log(error);
    });

  }


  amountAdd() {

    // this.values= this.values>0?this.values:null;
    this.gst = this.gst ? this.values : null;
    this.totalAmount = this.totalAmount ? this.values : null;
    this.btn = 'disabled';
    if (this.amount > 0) {
      this.condition = 'non-active';
      this.applyBtn = 'Apply';
      this.btn = 'non-disabled';
      this.discount = this.discount ? this.values : null;
      this.amount = this.amount;
      this.gst = (this.amount * 18 / 100);
      if (!this.gS.indiaZone) {
        this.gst = 0;
      }
      this.totalAmount = this.amount + this.gst;

    }
    else if (this.amount == 0) {
      this.toastr.error("wrong value", "Please enter correct amount");
      this.applyBtn = 'Apply';
      this.discount = this.discount ? this.values : null;
      this.gst = this.gst ? this.values : null;
      this.totalAmount = this.totalAmount ? this.values : null;
      this.btn = 'disabled';
    }
    else if (this.amount < 0) {
      this.toastr.error("wrong value", "Please enter correct amount");
      this.applyBtn = 'Apply';
      this.discount = this.discount ? this.values : null;
      this.gst = this.gst ? this.values : null;
      this.totalAmount = this.totalAmount ? this.values : null;
      this.amount = this.amount ? this.values : null;
      this.btn = 'disabled';
    }
    else {
      // this.condition = 'active';
    }
  }
  applyCouponCode() {
    // console.log('code');

    let payload = {
      customerId: this.customerId,
      amount: this.amount,
      couponCode: this.couponCode,
      platformType: "WEBSITE",
      timeZone: localStorage.getItem("timeZone")
    }
    this._homeService.checkCouponAvailability(payload).subscribe((data: any) => {

      // this.couponCode = data;
      // this.couponCode = this.couponCode.data;
      if (data?.status == 'success') {
        this.applyBtn = 'Applied';
        this.discount = data?.data?.cashbackAmount;
        this.couponId = data?.data?.id;
        console.log(this.discount);
        console.log(this.couponId);
      }

      else {
        this.toastr.error(data?.reason, "Error");

      }

    }, (error) => {
      console.log(error);
    });
  }
  changeCoupon() {

    // console.log('coupon');
    this.applyBtn = 'Apply';
    this.discount = this.discount ? this.values : null;
  }
}
